import './App.css';

import { Route, Routes } from 'react-router-dom';
import AuthDialogLogin from './dialog/LoginDialog';
import LandingPage from './pages/landingpage/LandingPage';
import { Provider } from 'react-redux';
import { store } from './Store';
import ModalMessageOkDialog from './dialog/ModalMessageOkDialog';
import Kontakt from './pages/misc/Kontakt';
import Impressum from './pages/misc/Impressum';
import Produkte from './pages/misc/Produkte';

export default function App() {

    return (
        <>
            <Provider store={store}>
                <AuthDialogLogin />
                <ModalMessageOkDialog />

                <Routes>
                    <Route path="/" element={<LandingPage />}></Route>
                    <Route path="/kontakt" element={<Kontakt />}></Route>
                    <Route path="/impressum" element={<Impressum />}></Route>
                    <Route path="/produkte" element={<Produkte />}></Route>            
                </Routes>
            </Provider>
        </>
    );
}
